/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateMultipleAllocationsInput = {|
  projectId?: ?string,
  idleTimeId?: ?string,
  projectGroupId?: ?string,
  allocations?: ?$ReadOnlyArray<?CreateAllocationInputType>,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type CreateAllocationInputType = {|
  personId?: ?string,
  startYear?: ?number,
  startMonth?: ?number,
  startDay?: ?number,
  endYear?: ?number,
  endMonth?: ?number,
  endDay?: ?number,
  monday?: ?number,
  tuesday?: ?number,
  wednesday?: ?number,
  thursday?: ?number,
  friday?: ?number,
  saturday?: ?number,
  sunday?: ?number,
  description?: ?string,
  idleTimeId?: ?string,
  projectId?: ?string,
  projectGroupId?: ?string,
  isSoft?: ?boolean,
|};
export type createMultipleAllocationsMutationVariables = {|
  input: CreateMultipleAllocationsInput
|};
export type createMultipleAllocationsMutationResponse = {|
  +createMultipleAllocations: ?{|
    +project: ?{|
      +id: string
    |}
  |}
|};
export type createMultipleAllocationsMutation = {|
  variables: createMultipleAllocationsMutationVariables,
  response: createMultipleAllocationsMutationResponse,
|};
*/


/*
mutation createMultipleAllocationsMutation(
  $input: CreateMultipleAllocationsInput!
) {
  createMultipleAllocations(input: $input) {
    project {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMultipleAllocationsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMultipleAllocationsPayload",
    "kind": "LinkedField",
    "name": "createMultipleAllocations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createMultipleAllocationsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createMultipleAllocationsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createMultipleAllocationsMutation",
    "operationKind": "mutation",
    "text": "mutation createMultipleAllocationsMutation(\n  $input: CreateMultipleAllocationsInput!\n) {\n  createMultipleAllocations(input: $input) {\n    project {\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8d0b603fa83afa6afbee98fa74a1ae00';

module.exports = node;
